<div class="item-container d-flex flex-column h-100">
    <div class="item-header ">
        <h6 class="text-center mb-0">{{"View Examsheet" | translate}}</h6>
        <div class="edit-icons cursor-pointer" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content" *ngIf="examData">
        <div class="item-img d-flex flex-column align-items-center pt-3 pt-lg-4">
            <img src="assets/images/object_icons/view_examsheet.png" class="img-fluid" alt="">
        </div>



        <table class="mt-2 mt-sm-3 mt-md-4" mat-table [dataSource]="dataSource"
        class="mat-elevation-z8">
          <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef >Title</th>
            <td mat-cell *matCellDef="let element" class="td-1">
                {{element.tit}}
            </td>
          </ng-container>
          <ng-container matColumnDef="attend_time">
            <th mat-header-cell *matHeaderCellDef> Attended Time</th>
            <td mat-cell *matCellDef="let element"> {{element.a_t |dates}} </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Exam Status</th>
            <td mat-cell *matCellDef="let element"> 
                <div class="badge-icon success-badge mt-3 m-auto" *ngIf="element.is_p==1">Passed</div>
                <div class="badge-icon failure-badge mt-3 m-auto" *ngIf="element.is_p==0">Failed</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="exam_sheet">
            <th mat-header-cell *matHeaderCellDef> Exam Sheet</th>
            <td mat-cell *matCellDef="let element">

              <button mat-flat-button color="warn" class=" gradient-green-btn   ms-3" type="submit"
              (click)="onDownload(examData.e_sht)">
              <img src="assets/images/icons/download.png" class="img-fluid me-1"> Download</button>
            </td>
          </ng-container>
          <ng-container matColumnDef="sign">
            <th mat-header-cell *matHeaderCellDef>Signature</th>
            <td mat-cell *matCellDef="let element">
                <div *ngIf="element.sign" class="sign-img" [style.backgroundImage]="'url(' + imageURL + element.sign + ')'">
                </div>
            </td>
          </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>